<template>
    <Card>
        <template v-slot:title>
            {{ __('orders.by_store') }}
        </template>

        <template v-slot:toolbar>
            <Link :href="$route('orders.statistics.stores', {filters: $page.props.initFilters})"
                  as="button"
                  class="btn btn-default btn-hover-primary btn-sm">
                <i class="fas fa-eye"/>
                {{ __('actions.view_thing', {thing: __('general.details')}) }}
            </Link>
        </template>

        <table class="table table-sm table-hover table-vertical-center table-borderless">
            <tbody>
            <tr v-for="storeStats in statistics.orders_by_stores">
                <td>
                    <Store :store="stores[storeStats.store_uuid]"/>
                </td>
                <td class="text-right text-lg">
                    {{ storeStats.order_count }}&nbsp;{{ __('orders.orders') }}
                </td>
            </tr>
            </tbody>
        </table>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Store from "@components/Store/Store.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {Store, Card, Link},

    props: {
        statistics: Object,
        stores: Object
    }
}
</script>
